/**
 * 최상위 레이아웃 컴포넌트
 * 통합 반응형 레이아웃을 렌더링합니다.
 * 전역적으로 사용되는 주소와 전화번호 정보를 API에서 가져와
 * Footer 컴포넌트에 전달합니다.
 */

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// 통합 반응형 컴포넌트
import Nav from '../template/Nav';
import Footer from '../template/Footer';
import Quick from './Quick';
import SpotSite from '../template/SpotSite';

// API 함수
import { getDirections } from '../Api';

/**
 * App 컴포넌트
 * @param {Object} props
 * @param {React.ReactNode} props.children - 라우팅된 페이지 컴포넌트
 */
function App({ children }) {
  // 주소와 전화번호를 저장하는 state
  const [address, setAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  /**
   * 컴포넌트 마운트 시 주소 및 전화번호 정보를 API에서 가져옵니다.
   * Footer 컴포넌트에서 사용할 데이터를 미리 로드합니다.
   */
  useEffect(() => {
    const fetchData = async () => {
      const directions = await getDirections();
      setAddress(directions.address);
      setPhoneNumber(directions.phoneNumber);
    };

    fetchData();
  }, []);

  return (
    <>
      {/* 통합 반응형 레이아웃: Nav, 콘텐츠, SpotSite, Footer, Quick 메뉴 */}
      <Nav />
      <Body>{children}</Body>
      <SpotSite />
      <Footer address={address} phoneNumber={phoneNumber} />
      {/* <Quick /> */}
    </>
  );
}

export default App;

/* Styled Components */

const Body = styled.div`
  width: 100%;
`;
